import {
  CreateGUFWellFunctionTask,
  EditGUFWellFunctionTask,
  QualityRegimeOptions,
} from "@nens/brostar/uploadapi-client";

import { BrostarUiSchema } from "@/libs/brostar-form";

import { createGufUiSchemaLibrary } from "./guf-ui-schema-library";

export function useGufWellFunctionUiSchema(
  qualityRegimeValue: QualityRegimeOptions | undefined
): BrostarUiSchema<CreateGUFWellFunctionTask | EditGUFWellFunctionTask> {
  const {
    projectNumber,
    qualityRegime,
    deliveryAccountableParty,
    broId,
    correctionReason,
    realisedWellId,
    wellFunctions,
    relativeTemperature,
    eventDate,
    realisedInstallationId,
    installationFunction,
  } = createGufUiSchemaLibrary(qualityRegimeValue);

  const uiSchema: BrostarUiSchema<CreateGUFWellFunctionTask | EditGUFWellFunctionTask> = {
    "ui:order": ["metadata", "sourcedocumentData"],
    metadata: {
      "ui:title": "Metadata",
      projectNumber,
      qualityRegime,
      deliveryAccountableParty,
      broId,
      correctionReason,
    },
    sourcedocumentData: {
      "ui:title": "Brondocumentgegevens",
      "ui:order": [
        "realisedWellId",
        "wellFunctions",
        "relativeTemperature",
        "eventDate",
        "realisedInstallationFunction",
      ],
      realisedWellId,
      wellFunctions,
      relativeTemperature,
      eventDate,
      realisedInstallationFunction: {
        "ui:order": ["realisedInstallationId", "installationFunction"],
        realisedInstallationId,
        installationFunction,
      },
    },
  };

  return uiSchema;
}
